import { render } from "./GlobalAppSidebar.vue?vue&type=template&id=37d9fa8d&scoped=true"
import script from "./GlobalAppSidebar.vue?vue&type=script&lang=js"
export * from "./GlobalAppSidebar.vue?vue&type=script&lang=js"

import "./GlobalAppSidebar.vue?vue&type=style&index=0&id=37d9fa8d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d9fa8d"]])

export default __exports__